"use strict";
/*
 * Created on 03 11 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Encapsulates id of {@link Family family} and distinct set of all its {@link FamilyBinding.sizeRatio lines}.
 *
 * @author JMe
 */


var FamilySizeRatios =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FamilySizeRatios, _DomainObject_1$Domai);

  /**
   * @param familyId internal id of family
   * @param sizeRatios set of all size ratios within family
   */
  function FamilySizeRatios(familyId, sizeRatios) {
    var _this;

    _classCallCheck(this, FamilySizeRatios);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilySizeRatios).call(this));
    _this.familyId = familyId;
    _this.sizeRatios = sizeRatios;
    return _this;
  }

  return FamilySizeRatios;
}(DomainObject_1.DomainObject);

exports.FamilySizeRatios = FamilySizeRatios;

FamilySizeRatios.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(FamilySizeRatios.name);
  return {
    familyId: builder.id('familyId'),
    sizeRatios: builder.listOf(builder.bigNum('sizeRatios'))
  };
}();